export const SourceReliabilityThyPrematureFailure = "reliabilitythyprematurefailures";
